import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { settings } from "../../Services/apiSetting";
import SeoHelmet from "./seoHelmet";
import { getProductFilters, getProductsUrl } from "./helpers";

export default function StaticSeoManager({ categoryName } = {}) {
  const location = useLocation();

  const [seoList, setSeoList] = useState({});
  const [seo, setSeo] = useState(null);

  const isDynamicProductPage = location.pathname.startsWith("/product/");

  useEffect(() => {
    if (isDynamicProductPage) {
      setSeo(null);
      return;
    }

    fetch(settings.staticSEOJsonUrl)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Failed to load SEO JSON: ${res.status}`);
        }

        return res.json();
      })
      .then((data) => {
        setSeoList(data);
      })
      .catch((error) => {
        console.error("Failed to load SEO JSON:", error);
        setSeoList({});
      });
  }, [isDynamicProductPage]);

  useEffect(() => {
    if (isDynamicProductPage) {
      setSeo(null);
      return;
    }

    const path = location.pathname.replace(/\/+$/, "") || "/";

    const pageSeo = seoList[path] || null;

    if (path !== "/products" || !pageSeo) {
      setSeo(pageSeo);
      return;
    }

    const filters = getProductFilters(location.search);
    const pageSuffix = filters.page > 1 ? ` - Page ${filters.page}` : "";
    const title = categoryName
      ? `${categoryName} Malaysia${pageSuffix} | Teamstar`
      : filters.page > 1
        ? `Products${pageSuffix} | Teamstar`
        : pageSeo.title;
    const description = categoryName
      ? `Browse ${categoryName.toLowerCase()} from Teamstar in Malaysia. Explore product details and specifications to find products for your project.`
      : pageSeo.description;
    const canonicalUrl = new URL(
      getProductsUrl({ ...filters, categoryName }),
      pageSeo.canonicalUrl,
    ).href;

    setSeo({
      ...pageSeo,
      title,
      description,
      canonicalUrl,
      robots:
        filters.search || filters.sort !== "date_asc"
          ? "noindex,follow"
          : pageSeo.robots,
      openGraph: { ...pageSeo.openGraph, title, description, url: canonicalUrl },
      twitter: { ...pageSeo.twitter, title, description },
      structuredData:
        pageSeo.structuredData?.["@type"] === "CollectionPage"
          ? {
              ...pageSeo.structuredData,
              name: categoryName || pageSeo.structuredData.name,
              description,
              url: canonicalUrl,
            }
          : pageSeo.structuredData,
    });
  }, [
    location.pathname,
    location.search,
    seoList,
    isDynamicProductPage,
    categoryName,
  ]);

  return <SeoHelmet seo={seo} />;
}
